// Limits of POST .../messages/:id/attachments — mirrored from
// backend/internal/services/ticketattachments/ticketattachments.go
// (MaxFileSizeBytes, MaxPerMessage, allowedMimes). The server stays the
// authority; checking here only spares the customer a failed upload.
export const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024
export const ATTACHMENT_MAX_FILES = 5
export const ATTACHMENT_MIMES = [
  'application/pdf',
  'application/zip',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/plain',
  'text/csv',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
]

// attachmentProblem returns why a file would be rejected, or null if it is fine.
export function attachmentProblem(file: { size?: number; type?: string }): 'tooLarge' | 'badType' | null {
  if ((file.size ?? 0) > ATTACHMENT_MAX_BYTES) return 'tooLarge'
  if (!ATTACHMENT_MIMES.includes(file.type ?? '')) return 'badType'
  return null
}
